import React from 'react';
import cn from 'classnames';
import classes from './Agreement.module.scss';
import AgreementCard from './AgreementCard';
import { useAppSelector } from 'store/hook';
import { useTranslation } from 'react-i18next';
import { Divider } from 'antd';
import AgreementActions from './AgreementActions';
import AgreementMessages from './AgreementMessages';
import AgreementUsers from './AgreementUsers';

type AgreementTabProps = {
  onDeclineOpen: () => void;
  usersWithPermissions: any[];
  loadingUsersPermissions: boolean;
}

const AgreementTab = ({onDeclineOpen, usersWithPermissions, loadingUsersPermissions}: AgreementTabProps) => {
  const { userPermissions } = useAppSelector((store) => store.userData);
  const { selectedDocument, selectedFolder, dataDocumentTable } = useAppSelector((state) => state.documents);
  const { agreementInfo, agreements } = useAppSelector((state) => state.agreements);

  const documentPermissions = dataDocumentTable.find(({ id }) => id === selectedDocument?.id)?.permissions!;

  const { t } = useTranslation();
  
  return (
    <div className={cn(classes.simpleWrap, classes.agreemensBlocks)}>
      <span className={classes.subTitle}>{t('Documents.details.agreement.agreementSetting')}</span>
      {userPermissions?.can_edit_agreement 
        && <AgreementCard
          selectedDocument={selectedDocument}
          selectedFolder={selectedFolder}
          documentPermissions={documentPermissions}
          usersWithPermissions={usersWithPermissions}
          loadingUsersPermissions={loadingUsersPermissions}
        />
      }
      
      <Divider style={{margin: '15px 0'}}/>

      <span className={classes.subTitle}>{t('Documents.details.agreement.agreementControl')}</span>
      <AgreementActions onDeclineOpen={onDeclineOpen} documentPermissions={documentPermissions} />

      <Divider style={{margin: '15px 0'}}/>

      <div className={classes.agreement_footer}>
        {agreements[0] && <AgreementUsers usersWithPermissions={usersWithPermissions} loadingUsersPermissions={loadingUsersPermissions} />}
        
        {agreementInfo?.comment && (
          <div className={classes.messages}>
            <div className={classes.messageTitle}>{t('Documents.details.agreement.agreementDeclineMessage')}</div>
            <AgreementMessages info={agreementInfo}/>
          </div>
        )}
      </div>
      
    </div>
  );
}

export default AgreementTab;
